// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__p59tN","footerInner":"style_footerInner__osCgH","logo":"style_logo__fc1ik"};